
import { defineComponent, reactive, ref } from 'vue';
import { useList } from '@/hooks/use-list';
import usePermissionConfig from './use-permission-config';
import {
  CONTRACT_STATUS_LIST,
  DATA_INPUT_STATUS_ENUM,
  DATA_INPUT_STATUS_LIST,
  DEMAND_CHANGE_ENUM,
  DEMAND_CHANGE_LIST,
  DEMAND_TASK_TYPE_LIST,
  PRICING_STATUS_ENUM,
  PRICING_STATUS_LIST,
  PRODUCTION_DEMAND_STATUS_ENUM,
  PRODUCTION_DEMAND_STATUS_LIST,
  PRODUCTION_PATTERN_LIST,
  REGION_LIST,
  YES_OR_NO_NUMBER_LIST,
} from '@/constant/production-demand';
import { getProductionDemandList } from '@/api/production-demand';
import { IProdDemandPageListItem, IProdDemandPageReq } from '@/api/production-demand/type';
import Logger from '@/views/production-demand/components/logger/main.vue';

export default defineComponent({
  components: {
    Logger,
  },
  setup() {
    const {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<IProdDemandPageListItem, IProdDemandPageReq>({
      request: {
        api: getProductionDemandList,
        params: {
          styleCodeLike: '',
          orderCodeLike: '',
          pageNum: 1,
          pageSize: 20,
        },
      },
    });

    // 原因详情
    const reasonData = reactive({
      visible: false,
      data: {} as IProdDemandPageListItem,
    });
    const handleReason = (row: IProdDemandPageListItem) => {
      reasonData.data = row;
      reasonData.visible = true;
    };

    // 日志
    const productionLogRef = ref();
    const logVisible = ref(false);
    const handleLog = (row: IProdDemandPageListItem) => {
      productionLogRef.value.show(row.demandDetailId);
      logVisible.value = true;
    };

    // 请求列表
    handleSearch();

    return {
      logVisible,
      productionLogRef,
      permissionConfig: usePermissionConfig(),
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,

      REGION_LIST,
      PRODUCTION_DEMAND_STATUS_ENUM,
      DEMAND_CHANGE_ENUM,
      DEMAND_CHANGE_LIST,
      PRODUCTION_PATTERN_LIST,
      PRODUCTION_DEMAND_STATUS_LIST,
      PRICING_STATUS_LIST,
      YES_OR_NO_NUMBER_LIST,
      CONTRACT_STATUS_LIST,
      DATA_INPUT_STATUS_LIST,
      DEMAND_TASK_TYPE_LIST,

      reasonData,
      handleReason,
      handleLog,

      // 生产资料录入样式
      getDataInputStatusClass(status: DATA_INPUT_STATUS_ENUM) {
        const statusMap = {
          1: 'warning',
          2: 'primary',
          3: 'success',
          4: 'info',
        };
        return `text-color-${statusMap[status]}`;
      },

      // 核价情况
      getPricingStateClass(state: PRICING_STATUS_ENUM) {
        // 暂时只定了这几种状态 的类型
        const stateMap = {
          30: 'warning',
          40: 'primary',
          60: 'success',
          70: 'info',
        } as any;
        return stateMap[state] ? `text-color-${stateMap[state]}` : '';
      },
    };
  },
});
